import { render, staticRenderFns } from "./LGPDModal.vue?vue&type=template&id=419303e5"
import script from "./LGPDModal.vue?vue&type=script&lang=js"
export * from "./LGPDModal.vue?vue&type=script&lang=js"
import style0 from "./LGPDModal.vue?vue&type=style&index=0&id=419303e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports